module.exports = __webpack_public_path__ + "static/logo_black-fc2dffb8755e3d2e6afd2f8e28371cac.png";